module.exports = __webpack_public_path__ + "static/media/verification-diagram.25275000.png";